/* セレクト */
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
var Select = function (_a) {
    var id = _a.id, label = _a.label, need = _a.need, sources = _a.sources, value = _a.value, handleChange = _a.handleChange, name = _a.name, message = _a.message, help_msg = _a.help_msg, disabled = _a.disabled, suffix = _a.suffix, handleBlur = _a.handleBlur, with_empty_option = _a.with_empty_option;
    var returnFormSelectJsx = function () {
        return suffix ? (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Form.Control, { id: id, as: "select", custom: true, onChange: handleChange, name: name, disabled: disabled, value: value, onBlur: handleBlur },
                        with_empty_option && React.createElement("option", null),
                        sources.map(function (src) {
                            return (React.createElement("option", { key: src.key, value: src.key }, src.value));
                        }))),
                React.createElement(Col, { md: 2, lg: 2, xl: 2 }, suffix)),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))) : (React.createElement(React.Fragment, null,
            React.createElement(Form.Control, { id: id, as: "select", custom: true, onChange: handleChange, name: name, disabled: disabled, value: value, onBlur: handleBlur },
                with_empty_option && React.createElement("option", null),
                sources.map(function (src) {
                    return (React.createElement("option", { key: src.key, value: src.key }, src.value));
                })),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message })));
    };
    var returnLabelJsx = function () {
        return suffix ? (React.createElement(React.Fragment, null, sources.map(function (src, index) {
            if (typeof value !== 'undefined' && value !== null) {
                value = String(value);
            }
            if (src.key === value) {
                return React.createElement(Paragraph, { key: index, label: "" + src.value + suffix });
            }
        }))) : (React.createElement(React.Fragment, null, sources.map(function (src, index) {
            if (typeof value !== 'undefined' && value !== null) {
                value = String(value);
            }
            if (src.key === value) {
                return React.createElement(Paragraph, { key: index, label: src.value });
            }
        })));
    };
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? returnLabelJsx() : returnFormSelectJsx() }));
};
export default Select;
